import React, { useState, useEffect } from 'react';

import { makeStyles } from '@mui/styles';


import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard } from "@fortawesome/pro-regular-svg-icons";

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import CircularProgress from '@mui/material/CircularProgress';

import DialogX from './Dialog';
import CustomerSearch from './CustomerSearch';

import {getConfigValue} from './Config';


const useStyles = makeStyles(theme => ({   
    
    outerRow: {
        fontFamily:'Mulish', 
        display: 'flex', 
        flexDirection: 'row',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',
        // marginLeft: '.5em',
        // marginTop: '.5em',       
        backgroundColor:'#F3F3F3',
        // padding: '.5em',
        // paddingTop:'1em',
        width:'100%',
        borderRadius: '3px',
        fontSize: '9pt',
       

    },
    linkedAccountsList: {
        overflow: 'auto',
        maxHeight: '160px',
        width: '400px',
        minWidth: '400px',
      },

    actionButtonRow: {
        display: 'flex', 
        flexDirection: 'row',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',
        
        margin: '1em',
        
    }
   

    }));

    


const LinkedAccounts = (props) => {
    const classes = useStyles();
    var store = require('store')
   
    const [dialogOpen, setDialogOpen] = useState();
    const [dialogText, setDialogText] = useState('');

    const [loadingButtons, setLoadingButtons] = useState({});
    const [isFetching, setIsFetching] = useState(false);

    const [linkedAccounts, setLinkedAccounts] = useState([]);
    const [selectedLinkedAccount, setSelectedLinkedAccount] = useState();
    const [accountToLink, setAccountToLink] = useState();

    const [userConfirmedOperation, setUserConfirmedOperation] = useState();
    
   
    const isLoading = (buttonName) => {
        return loadingButtons[buttonName];
    }

    const setLoading =(buttonName, isLoading) => {
        var ldnButtons = {...loadingButtons};
        ldnButtons[buttonName] = isLoading;
        setLoadingButtons(ldnButtons);        
    }

 

    const onSelectCustomerForLinking = (account) => {
        setAccountToLink(account)
    }

    const confirmRemoveLinkedAccount =() => {
        setUserConfirmedOperation(() =>removeLinkedAccount)
        setDialogText(`Ønsker slette koblingen mellom ${selectedLinkedAccount.DisplayName}(${selectedLinkedAccount.Id}) 
                        og ${props.customer.DisplayName}(${props.customer.Id}) ?`)

        setDialogOpen(true);
    }

    const removeLinkedAccount = async (confirmed) => {
        if (!confirmed)
            return; //cancel operation

        setLoading("removeLinkedAccount", true)

        const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/removeLinkedAccount/${store.get("sessionToken")}/${props.customer.Id}/${selectedLinkedAccount.Id}`);            
        const json = await res.json();   
                
        if (json["errorCode"]=='440'){        
            console.log("En feil oppstod, lenket konto kunne ikke fjernes.");   
        }              
        else if (json["result"]=='success') {
            fetchLinkedAccounts();
        }
            
        setLoading("removeLinkedAccount", false)

        props.refreshParent(); //redraw admin gui, show correct invoiceListViews
    }

    const confirmLinkAccount = () => {
        setUserConfirmedOperation(()=>linkAccount)
        setDialogText(`Ønsker du å koble sammen kontoene ${props.customer.DisplayName}(${props.customer.Id}) 
                        og ${accountToLink.DisplayName}(${accountToLink.Id})?`)

        setDialogOpen(true);
    }

    const linkAccount = async (confirmed) => {
        if (!confirmed)
            return; //cancel operation

        setLoading("linkAccounts", true)

        const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/linkAccounts/${store.get("sessionToken")}/${props.customer.Id}/${accountToLink.Id}`);            
        const json = await res.json();   
                
        if (json["errorCode"]=='430'){        
            console.log("En feil oppstod, konti kunne ikke kobles sammen.");   
        }              
        else if (json["result"]=='success') {
            fetchLinkedAccounts();
        }
           
        setLoading("linkAccounts", false)

        props.refreshParent(); //redraw admin gui, show correct invoiceListViews
    }

    useEffect(() =>  { //run once on load
        fetchLinkedAccounts();    
        
    },[props.doRefresh])


    const fetchLinkedAccounts = async () => {        
        setSelectedLinkedAccount(null);
        setLinkedAccounts([]);
        setIsFetching(true);

        const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/getLinkedAccounts/${store.get("sessionToken")}`);            
        const json = await res.json();   
               
        if (json["errorCode"]=='420'){        
            console.log("En feil oppstod, sammenkoblede konti kunne ikke hentes.");   
        }              
        else if (json["result"]=='success') {            
            setLinkedAccounts(json["linkedAccounts"]);
        }
        console.log(json["linkedAccounts"]);
        setIsFetching(false);
    }

    return(              

        <div style={{marginTop: '.5em'}}>
        {dialogOpen && <DialogX dialogText={dialogText} onCompletionFunc={userConfirmedOperation} setDialogOpen={setDialogOpen}/> } 
        

        <Accordion style={{backgroundColor: '#F3F3F3',marginLeft: '.5em'}} >
         <AccordionSummary style={{backgroundColor: '#F3F3F3'}}
          expandIcon={<ExpandMoreIcon />}                  
        >
          Sammenkoblede konti ({linkedAccounts.length})
          
        </AccordionSummary>
         
        <AccordionDetails>        
        <div className={classes.outerRow}> 


            
            <div>
            { isFetching && <CircularProgress /> }

            <List className={classes.linkedAccountsList} dense={true}>
                {linkedAccounts.map((item,index) => 
                    <ListItem key={item.ApiId} selected={item===selectedLinkedAccount} onClick={() =>setSelectedLinkedAccount(item)}>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faIdCard} />
                        </ListItemIcon>
                        <ListItemText
                            primary={item.DisplayName}
                            secondary={'ApiId: ' + item.ApiId}
                        />
                    </ListItem>
                )}               
            </List>

            <div className={classes.actionButtonRow}>
                <LoadingButton loading={isLoading("linkAccounts")}onClick={confirmLinkAccount} disabled={!accountToLink} inputProps={{style: {fontSize: 12}}} style={{width: '130px'}} variant="contained" size='small' color="primary">Koble Konto</LoadingButton>                                 
                &nbsp;&nbsp;
                <LoadingButton loading={isLoading("removeLinkedAccount")} onClick={confirmRemoveLinkedAccount} disabled={!selectedLinkedAccount} inputProps={{style: {fontSize: 12}}} style={{width: '130px'}} variant="contained" size='small' color="primary">Slett Kobling</LoadingButton> 
            </div> 
            
            
            </div>

            <CustomerSearch onSelectCustomer={onSelectCustomerForLinking}/>
            
                       
            
           
        </div>

        

        </AccordionDetails>
        </Accordion>
        

        </div>
    )
    
};

export default LinkedAccounts;